import { Pipe, PipeTransform } from '@angular/core';

/** Limpia RUT a dígitos + K (misma regla que API). */
export function cleanRut(value: string | number | null | undefined): string {
  if (value == null || value === '') return '';
  return String(value).replace(/[^0-9kK]/g, '').toUpperCase();
}

/**
 * Formato visual Chile: 12.345.678-9
 * (el valor persistido puede ir sin puntos/guión).
 */
export function formatRut(value: string | number | null | undefined): string {
  const raw = cleanRut(value);
  if (!raw) return '';
  const body = raw.slice(0, -1);
  const dv = raw.slice(-1);
  if (!body) return dv;
  const withDots = body.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${withDots}-${dv}`;
}

@Pipe({
  name: 'rutFormat',
  standalone: true,
})
export class RutFormatPipe implements PipeTransform {
  transform(value: string | number | null | undefined): string {
    return formatRut(value);
  }
}
